export enum Status {
	PUBLISHED = 'PUBLISHED',
	ARCHIVED = 'ARCHIVED',
	DRAFT = 'DRAFT',
}
